/**
 * @generated SignedSource<<59b5ac5ec5308218c593ccd09cce13d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type newsletterWidgetLiveArticleArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentNewsletterWidgetContent">;
  readonly " $fragmentType": "newsletterWidgetLiveArticleArticle";
};
export type newsletterWidgetLiveArticleArticle$key = {
  readonly " $data"?: newsletterWidgetLiveArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"newsletterWidgetLiveArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "newsletterWidgetLiveArticleArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentNewsletterWidgetContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "8679a4c69cd05fd8ba34c86a156721c8";

export default node;
